@if (loadingUserinfo) {
    <it-column
        padding="0"
        clampHeight="100vh"
        axisX="center"
        axisY="center"
        [backgroundColor]="ColorEnum.SECONDARY_COLOR"
    >
        <it-column
            padding="0"
            flex="1"
            axisX="center"
            axisY="center"
            [backgroundColor]="ColorEnum.SECONDARY_COLOR"
        >
            <it-spinner
                [color]="ColorEnum.PRIMARY_COLOR_TEXT"
                fontSize="2rem"
            />

            <it-text
                [color]="ColorEnum.PRIMARY_COLOR_TEXT"
                i18n="@@login.userinfo.loading"
                >Authenticating</it-text
            >
        </it-column>
    </it-column>
} @else {
    <router-outlet />
}
